module.exports = __webpack_public_path__ + "img/picture_news_01.eb8249b4.png";